<template>
    <div class="campo-form">
        <div class="label-container">
            <label>{{ label }}<span style="color: #bb2a17" v-if="required">*</span></label>
            <slot name="acoes"></slot>
        </div>
        <div class="input-wrapper">
            <InputMask
                class="input"
                mask="(99) 99999-9999"
                :placeholder="placeholder"
                :name="name"
                v-model="inputValue"
                @update:modelValue="emit('update:modelValue', $event)"
            />
            <i v-if="showIcon" class="material-symbols-outlined icone-personalizado">expand</i>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue';
import InputMask from 'primevue/inputmask';

const props = defineProps({
    label: String,
    placeholder: String,
    name: String,
    modelValue: String,
    required: Boolean,
    showIcon: Boolean,
    timestampLimpeza: Number,
});

const emit = defineEmits(['update:modelValue']);
const inputValue = ref(props.modelValue || '');

watch(
    () => props.timestampLimpeza,
    (newValue, oldValue) => {
        if (newValue !== oldValue) {
            inputValue.value = '';
        }
    }
);
</script>

<style scoped lang="scss">
.campo-form {
    width: 100%;

    .input-wrapper {
        position: relative;
        width: 100%;
    }

    .input {
        width: 100%;
    }

    .label-container {
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        color: #252529;
    }

    .icone-personalizado {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        cursor: grab;
        color: #adb5bd;
    }
}
</style>
